module.exports = __webpack_public_path__ + "img/14.cbe8f8e9.svg";